export default "__VITE_ASSET__DH7meNl6__"